import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";

import { SyncMapItemTask } from "../store/definitions";
import {
    messageAgentJoinDateContainerStyles,
    messageAgentJoinContainerStyles,
    messageAgentJoinLineStyles,
    messageAgentJoinTextStyles
} from "./styles/MessageAgentJoin.styles";

export const MessageAgentJoin = ({ joinTask }: { joinTask: SyncMapItemTask }) => {
    return (
        <>
            <Box {...messageAgentJoinDateContainerStyles}>
                <Text as="p" {...messageAgentJoinTextStyles}>
                    {new Date(joinTask.date).toLocaleString()}
                </Text>
            </Box>
            <Box {...messageAgentJoinContainerStyles} data-test="new-message-separator" role="separator">
                <Box {...messageAgentJoinLineStyles} aria-hidden="true" />
                <Text as="p" {...messageAgentJoinTextStyles}>
                    Your are now chatting with {joinTask.workerName.split(" ").at(0)}
                </Text>
                <Box {...messageAgentJoinLineStyles} aria-hidden="true" />
            </Box>
        </>
    );
};
